// extracted by mini-css-extract-plugin
export default {"container":"style_container__DrbNW","card":"style_card__SwE6P","row":"style_row__zGHlo","btnsRow":"style_btnsRow__gNVF2"};